import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import LandingPage from '@components/pages/LandingPage';

registerWithErrorBoundary({
  LandingPage,
});
